import Icon from '../../components/Icon.vue'

Icon.register({"brands/trello":{"width":448,"height":512,"paths":[{"d":"M392 32H56C25.1 32 0 57.1 0 88V424C0 454.9 25.1 480 56 480H392C422.9 480 448 454.9 448 424V88C448 57.1 422.9 32 392 32zM194.9 371.4C194.9 386.2 182.9 398.3 168 398.3H85.1C70.3 398.3 58.2 386.3 58.2 371.4V117.1C58.2 102.3 70.2 90.2 85.1 90.2H168C182.8 90.2 194.9 102.2 194.9 117.1V371.4zM389.8 259.4C389.8 274.2 377.8 286.3 362.9 286.3H280C265.2 286.3 253.1 274.3 253.1 259.4V117.1C253.1 102.3 265.1 90.2 280 90.2H362.9C377.7 90.2 389.8 102.2 389.8 117.1V259.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/trello.js
// module id = null
// module chunks = 